import { render, staticRenderFns } from "./Zzlist.vue?vue&type=template&id=392dd017&scoped=true"
import script from "./Zzlist.vue?vue&type=script&lang=js"
export * from "./Zzlist.vue?vue&type=script&lang=js"
import style0 from "./Zzlist.vue?vue&type=style&index=0&id=392dd017&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392dd017",
  null
  
)

export default component.exports